import {
  SAVE_RECORDING_METADATA,
  SAVE_RECORDING_METADATA_SUCCESS,
  SAVE_RECORDING_METADATA_FAILURE,
} from './constants';

const initialState = {
  loading: false,
  recording: null,
  error: null,
  success: false,
  // videoLibraryData: {
  //   recordings: [],
  //   totalPages: 0,
  //   currentPage: 1,
  //   loading: false,
  // },
};

const videoLibrary = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_RECORDING_METADATA:
      return { ...state, loading: true, success: false, error: null };

    case SAVE_RECORDING_METADATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        recording: action.payload,
      };

    case SAVE_RECORDING_METADATA_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
      };
    // case GET_ALL_RECORDINGS:
    //   return {
    //     ...state,
    //     videoLibraryData: {
    //       ...state.videoLibraryData,
    //       recordings: [],
    //       loading: true,
    //     },
    //   };
    // case GET_ALL_RECORDINGS_SUCCESS:
    //   return {
    //     ...state,
    //     videoLibraryData: {
    //       ...action.payload,
    //       loading: false,
    //     },
    //   };
    // case GET_ALL_RECORDINGS_ERROR:
    //   return {
    //     ...state,
    //     videoLibraryData: {
    //       recordings: [],
    //       loading: false,
    //     },
    //     error: action.error,
    //   };
    default:
      return state;
  }
};

export default videoLibrary;
